// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__mjpJu","inputWrap":"CustomTip_inputWrap__1Eho4"};